// Canonical client-side password policy — mirrors api/validators/password_policy.py (#394).
// The blocklist is checked FIRST so every entry is reachable, matching the backend ordering.

const WEAK_PASSWORDS = [
  'password123!',
  'admin123!@#',
  'welcome123!',
  'qwerty123!@#',
  '123456789!@#',
];

const SPECIAL = /[!@#$%^&*()_+\-=[\]{}|;:,.<>?/\\`~'"]/;

export function validatePassword(pwd: string): string | null {
  if (WEAK_PASSWORDS.includes(pwd.toLowerCase()))
    return 'Password is too common. Please choose a stronger password';
  if (pwd.length < 12) return 'Password must be at least 12 characters long';
  if (!/[A-Z]/.test(pwd) || !/[a-z]/.test(pwd) || !/[0-9]/.test(pwd) || !SPECIAL.test(pwd))
    return 'Password must contain uppercase, lowercase, digit, and special character';
  return null;
}
